// *******************************************************
// Basket Actions
// -------------------------------------------------------

// *******************************************
// Action Type Imports
// -------------------------------------------
import ACTIONS from './index';
// --------------------------------

// *******************************************
// Action Definitions
// -------------------------------------------
export const sendItemsToKitchen = (itemType, items) => {
    return {
        type: ACTIONS.TYPES.SEND_ITEMS_TO_KITCHEN,
        itemType,
        items
    };
}
// --------------------------------



// WEBPACK FOOTER //
// ./src/actions/kitchen.js